// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"92":"5a005d4e","448":"a07172a1","894":"5a005d4e"}[chunkId] + ".chunk.css";
};